import React from "react"
import "./styles.scss"

const PageSummary = ({ children, className }) => {
    return <div className={`page-summary ${!!className ? className : ''}`}>{children}</div>
}

export default PageSummary
